module.exports = __webpack_public_path__ + "static/media/All-Binary-White.9ac83e13.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/All-Binary-White.png
// module id = 95
// module chunks = 0